import courierInvoicesEn from './en/courierInvoices.json';
import courierInvoicesEs from './es/courierInvoices.json';

export const courierInvoicesModuleEn = courierInvoicesEn;
export const courierInvoicesModuleEs = courierInvoicesEs;
